import { useEffect, useState } from "react";
import { listenToActiveCategories } from "../services/categoryService";
import { SERVICE_CATEGORIES } from "../lib/services";

const workflowFallbacks = [
  { id: "dry_cleaning", name: "Fabric Care", description: "Dry cleaning, pressing and garment-care services.", imageUrl: SERVICE_CATEGORIES[0].image },
  { id: "fabric_store", name: "Fabric Store", description: "Browse fabrics and choose material for your next order.", imageUrl: SERVICE_CATEGORIES[1].image },
  { id: "tailoring_materials", name: "Tailoring Materials", description: "Shop tailoring tools, accessories and supplies.", imageUrl: SERVICE_CATEGORIES[2].image },
  { id: "machine_services", name: "Tailor Machine Services", description: "Book sewing-machine repair and maintenance.", imageUrl: SERVICE_CATEGORIES[3].image },
  { id: "costume_rentals", name: "Costume Rentals", description: "Rent or purchase occasion and performance costumes.", imageUrl: SERVICE_CATEGORIES[0].image },
  { id: "home_measurement", name: "Home Measurement", description: "Schedule doorstep measurement collection.", imageUrl: SERVICE_CATEGORIES[4].image },
];

const fallbackCategories = SERVICE_CATEGORIES.map((category, index) => ({
  id: category.id,
  name: category.title,
  description: category.tagline,
  imageUrl: category.image,
  displayOrder: index,
  isActive: true,
})).concat(workflowFallbacks.map((category, index) => ({
  ...category,
  displayOrder: SERVICE_CATEGORIES.length + index,
  isActive: true,
})));

export function useCategories() {
  const [categories, setCategories] = useState(fallbackCategories);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categoriesError, setCategoriesError] = useState(null);

  useEffect(() => {
    const unsubscribe = listenToActiveCategories(
      (data) => {
        setCategories(data.length ? data : fallbackCategories);
        setCategoriesLoading(false);
        setCategoriesError(null);
      },
      (error) => {
        console.error("Unable to load categories:", error);
        setCategories(fallbackCategories);
        setCategoriesError(null);
        setCategoriesLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return {
    categories,
    categoriesLoading,
    categoriesError,
  };
}